import windowWrapper from '../utils/window-wrapper';

interface WindowWrapper {
  apiPrefix?: string;
}

export default class Api {
  /**
   * Simple wrapper around fetch to throw errors when response is not a 2XX. By default, fetch will return an Resolvable
   * Promise when Response.ok=false which can be confusing. This also coordinates simple retries in the event of an error
   */
  async request(url: string, init: RequestInit, retries = 2): Promise<Response> {
    let errorMessage = '';
    let response;
    // We set this prefix to call proxy endpoints from the myHeggerty frontend.
    const urlPrefix = windowWrapper.get<WindowWrapper>('apiPrefix')
      ? windowWrapper.get<WindowWrapper>('apiPrefix')
      : '';
    try {
      response = await fetch(`${urlPrefix}${url}`, init);
    } catch (err: any) {
      errorMessage = `Error calling fetch: ${err.message}`;
    }

    if ((response && response.status > 499) || errorMessage) {
      if (response) {
        errorMessage = `Received non-200 response: ${response.statusText}: ${await response.clone().text()}`;
      }
      if (retries > 0) {
        // eslint-disable-next-line no-console
        console.error(`There was an error while requesting ${url} with options ${JSON.stringify(init)}, retrying
        ${retries} more time(s): ${errorMessage}`);
        return this.request(url, init, retries - 1);
      }
    }
    if (response) {
      return response;
    }
    throw new Error(
      `Unrecoverable error while requesting ${url}. Most recent error message: ${errorMessage}. Request options ${JSON.stringify(
        init,
      )}`,
    );
  }
}
